<template>
  <div class="c-toolbar" v-if="!inLoader">
    <div
      class="item"
      v-if="type === 'CYBERBOARD' || type === 'AM RGB 65'"
      @click="$router.push($paths.library)"
    >
      <i class="iconfont iconjianpan" />
      <span class="text">{{ $t("ledPanelLibrary") }}</span>
      <i class="iconfont iconjinru" />
    </div>
    <div
      class="item"
      v-if="type === 'CYBERBOARD' || type === 'AM RGB 65'"
      @click="$router.push($paths.publish)"
    >
      <i class="iconfont icontougao" />
      <span class="text">{{ $t("publish.publish") }}</span>
      <i class="iconfont iconjinru" />
    </div>
    <div
      class="item"
      v-if="type === 'CYBERBOARD' && version === 'r1'"
      @click="onDownloadR1"
    >
      <i class="iconfont iconwindows" />
      <span class="text">{{ $t("loader.name") }}</span>
      <i class="iconfont icondownload" />
    </div>
    <div class="item" v-else @click="onDownload('windows')">
      <i class="iconfont iconwindows" />
      <span class="text">{{ $t("loader.name") }}</span>
      <i class="iconfont icondownload" />
    </div>
    <div
      class="item"
      @click="onDownload('mac')"
      v-if="!(type === 'CYBERBOARD' && version === 'r1')"
    >
      <i class="iconfont iconapple-fill" />
      <span class="text">{{ $t("loader.name") }}</span>
      <i class="iconfont icondownload" />
    </div>
    <div
      class="item"
      @click="historyVersion"
      v-if="!(type === 'CYBERBOARD' && version === 'r1')"
    >
      <i class="iconfont iconhistory-history" />
      <span class="text">{{ $t("historyVersion") }}</span>
      <i class="iconfont icondownload" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { download } from "@/utils";
import api, { url } from "@/api";

export default {
  name: "CToolbar",
  props: {
    type: String,
  },
  computed: {
    ...mapState("loader", {
      inLoader: "inLoader",
    }),
    ...mapState("assets", {
      oss: "oss",
    }),
    ...mapState("profile", {
      version: "version",
    }),
  },
  methods: {
    onDownloadR1() {
      download(this.oss.r1Setup);
    },
    onDownload(platform) {
      api
        .getLoaderList(platform)
        .then((res) => {
          if (res.data && res.data[0]) {
            download(res.data[0].url);
          }
        })
        .catch(() => {
          this.$message.info(this.$t("error.downloadFailed"));
        });
    },
    historyVersion() {
      window.open(url.AMMasterHistory, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.c-toolbar {
  position: fixed;
  top: 100px;
  right: 0;
  z-index: 1000;

  .item {
    @include flex-center;
    width: 220px;
    height: 70px;
    z-index: 1000;
    background: #3d3d3d;
    padding: 0 20px;
    border-radius: 10px 0px 0px 10px;
    font-size: 20px;
    margin-bottom: 20px;
    cursor: pointer;

    &:hover {
      background: $active-color;
    }

    .text {
      flex: auto;
      text-align: left;
    }

    .iconfont {
      font-size: 30px;
      margin-right: 10px;

      &:last-child {
        font-size: 24px;
        margin-right: 0;
      }
    }
  }
}
</style>
